// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22":"5fbdb12f6f1ab446","836":"8810eec141bc7d90"}[chunkId] + ".css";
};